import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSplitSharesIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5362 0C8.45234 0 6.41527 0.606259 4.6826 1.74211C2.94993 2.87796 1.59948 4.4924 0.802025 6.38125C0.00456516 8.2701 -0.204087 10.3485 0.202455 12.3537C0.608996 14.3589 1.61247 16.2008 3.08598 17.6465C4.5595 19.0922 6.43687 20.0767 8.48069 20.4755C10.5245 20.8744 12.643 20.6697 14.5682 19.8873C16.4935 19.1049 18.139 17.78 19.2967 16.0801C20.4545 14.3801 21.0724 12.3816 21.0724 10.3371C21.0643 7.59795 19.9517 4.97326 17.9775 3.0364C16.0033 1.09953 13.3281 0.00790913 10.5362 0ZM11.5898 2.13978C13.4434 2.37253 15.1659 3.20213 16.4872 4.49852C17.8086 5.79492 18.6542 7.48483 18.8914 9.30337H11.5898V2.13978ZM2.10724 10.3371C2.1136 8.32539 2.8653 6.3846 4.22225 4.87643C5.57919 3.36826 7.44878 2.39562 9.48258 2.13978V18.5447C7.44862 18.2849 5.5799 17.3096 4.22347 15.8001C2.86704 14.2906 2.11508 12.3494 2.10724 10.3371ZM11.5898 18.5344V11.3708H18.8914C18.6562 13.1901 17.8113 14.8812 16.4896 16.178C15.1678 17.4747 13.4442 18.3037 11.5898 18.5344Z",
		fill: "currentColor"
	})
});
export default SvgSplitSharesIcon;
